<template>
<div class="login ui-login" :style="{height: mobileHeight + 'px'}">
  <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" class="hidden-md hidden-lg">> </v-topBar>
  <div class="loginMain" :style="{height: (bodyHeight < 740 ? 635 : bodyHeight - 105) + 'px'}">
    <div v-show="switchPrompt" class="purchaserMask hidden-xs hidden-sm" style="width: 100%;height: 100%;background: rgba(0, 0, 0, 0.75);position: fixed;z-index: 1052;top: 0px;left: 0px;"></div>
    <div class="loginCon hidden-xs">
      <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/login_logo.png" alt="" @click="jump()">
    </div>
      <form class="el-form">
        <h3>登录</h3>
        <div class="el-form-item" ref="loginForm">
          <div class="el-form-item__content">
            <div class="el-input el-input--prefix">
              <input type="text" autocomplete="off" placeholder="请输入注册邮箱" class="el-input__inner" ref="inputUserName" v-model="loginUser" @keyup.enter="login()" @input="trimEmile(loginUser)">
              <span class="el-input__prefix">
                <i class="el-input__icon"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/user_icon.png" alt=""></i>
              </span>
            </div>
          </div>
        </div>
        <div class="el-form-item">
          <div class="el-form-item__content">
            <div class="el-input el-input--prefix">
              <input type="password" autocomplete="off" placeholder="请输入密码" class="el-input__inner" ref="inputPassword"  v-model="loginPass" @keyup.enter="login()">
              <span class="el-input__prefix">
                <i class="el-input__icon"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/password_icon.png" alt=""></i>
              </span>
            </div>
          </div>
        </div>
        <div class="el-form-item verifyCode" v-if="loginFailNumber>3">
          <div class="el-form-item__content">
            <div class="el-input el-input--prefix clearfix">
              <input type="text" class="el-input__inner pull-left" placeholder="请输入验证码"   ref="verifyCode" v-model="verifyCodeExt"  @keyup.enter="login()" />
              <span class="el-input__prefix">
                <i class="el-input__icon"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/verifyCode_icon.png" alt=""></i>
              </span>
              <img id="verifyCode" class="pull-left" :src="verrifyCodeUrl" alt="验证码出不来,请点击" @click="changeVerifyCode()">
              <a @click="changeVerifyCode()" class="verrifyChange pull-left"></a>
            </div>
          </div>
        </div>


        <div class="passwordSet hidden-xs clearfix">
          <!--<label role="checkbox" class="el-checkbox">-->
            <!--<span aria-checked="mixed" class="el-checkbox__input"><span class="el-checkbox__inner"></span>-->
              <!--<input type="checkbox"   id="checkbox" name="checkbox"  v-model="rememeberPassword" @click="checkItem($event)">-->
            <!--</span>-->
            <!--<span class="el-checkbox__label">记住密码</span>-->
          <!--</label>-->
          <el-checkbox id="checkbox" name="checkbox"  v-model="rememeberPassword" @click="checkItem($event)"  @keyup.enter.native="login()">记住密码</el-checkbox>
          <a class="pull-right" @click="goToHref('/findPassword')">忘记密码？</a>
        </div>
        <button type="button" class="el-button el-button--primary" @click="login()"><span>登录</span></button>
        <p class="leadStep hidden-xs">
          <transition name="el-fade-in">
            <div class="purchaserLeadStep" v-show="switchPrompt">
              <p>【新一链网】已经上线啦，还不赶快来看看<el-checkbox v-model="checkedPrompt">不再提醒</el-checkbox><br></p>
              <el-button @click.stop="toNewSite">关闭</el-button>
              <div class="leadArrowDown">
                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
              </div>
            </div>
          </transition>
          <a href="https://ebs.onelinkplus.com/uaa/login">登录新一链网</a>
          </p>
        <p class="hidden-xs">没有一链账号？<a @click="goToRegister">立即注册</a></p>
        <p class="hidden-xs2 login-mt10">没有一链账号？<a @click="goToRegister2()">立即注册</a></p>
        <p class="cursor-pointer toggle-lang" @click="$router.push('/loginEn')">Click here to visit the English website</p>
      </form>
  </div>
  <div class="footerBottom">
    <p>
      <span style="cursor: pointer"><a href="http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&serial=9031000020180928141425000002866592-SAIC_SHOW_310000-2018122018594033566&signData=MEYCIQCnB/Y+kI/GVR1Y8azeek7w7m7dnx1ziJ82bb+bl/0jBwIhAJMECiAYasxbH+nRD7qS1010iwZUN6zgz3xWGmv8fHqC" target="_blank"><img :src="webConfigInfo.businessCertificationAttachmentUrl" alt="">{{webConfigInfo.websiteAuthorization}} 本公司保留一切版权</a></span>
    <!--<span>备案证书号：{{webConfigInfo.publicNetworkSecurityNumber}}</span>-->
    </p>
    <p>
      <span  style="cursor: pointer"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/ghs.png" alt=""><a stle="text-decoration:none" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002003624" target="view_window">公安备案号：31011002003624</a></span>
      <span><a stle="text-decoration:none" href="https://beian.miit.gov.cn" target="view_window">备案证书号：沪ICP备05004652号-8</a></span>
      <span ><a stle="text-decoration:none" href="https://beian.miit.gov.cn" target="view_window">增值电信业务经营许可证：沪B2-20190630</a></span>
    </p>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex'
  import Cookies from 'js-cookie'
  import topBar from '@/components/topBar'
  import { customRegisterButtonClick } from '@/assets/js/sensors'

  export default {
    data () {
      return {
        password:"",
        userName:"",
        rememeberPassword:false,
        userInfo:{},
        companyInfo:{},
        loginFlag:false,
        checkFlag:false,
        messageNumber:'',
        redirectURL:'',
        navigationColumnInfos: [],
        footerColumnInfos:[],
        webConfigInfo: {},
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        accountInfo:{},
        rememberInfo:{},
        loginUser:'',
        loginPass:'',
        regeisterType:'',
        checkCardInfo:{},
        userTag:'',
        isCompanyManager:false,
        verrifyCodeUrl:'',
        verifyCode:'',
        verifyCodeExt:'',
        checkVerifyFlag:false,
        loginFailNumber:0,
        openId:'',
        coordinationSupplierAuthFlag:false,
        coordinationSystemAuthFlag:false,
        supplierManagerAuthFlag:false,
        checkIsWanbangGroup:false,
        isOperateQuestionNaire:false,
        privacyPolicyFlag:false,
        supplierRegeisterSuccessFlag:false,
        noticeInfos:[],
        isExperience:'',
        bodyHeight: '100%',
        mobileHeight: '100%',
        currentVerifyCode: '',
        mingyuanFlag:'',
        switchPrompt:true,
        checkedPrompt:false
      }
    },
    components: {
      'v-topBar': topBar,
    },
    mounted(){
      this.resizeBody();
      this.mobileBody();
      window.onresize = () => this.resizeBody();

    },
    created () {
      if(this.getToken('isRemember') == 100 || (this.$route.query.type && this.$route.query.type == 'en')){
        this.rememberInfo = JSON.parse(this.getDAesString(this.getToken('rememberInfo'),this.KP.key,this.KP.iv));
        this.userName  = this.rememberInfo.userName;
        this.password  = this.rememberInfo.password;
        this.loginUser = this.userName ;
        this.loginPass = this.password;
        this.rememeberPassword = this.getToken('isRemember') == 100
      }else{
        this.loginUser = "" ;
        this.loginPass = "";
        this.rememeberPassword = false;
      }
      this.loginFailNumber = this.getToken('loginFailNumber');
      let query = this.$route.query;
      this.redirectURL = query.redirectURL ? decodeURIComponent(query.redirectURL) : '';
      this.openId = query.openId;
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
        this.verrifyCodeUrl = this.data.verrifyCodeUrl+"?operateType=login_&?date=" + encodeURI(encodeURI(new Date()));
      }).catch((err) => {
        console.log(err)
      })
      this.loginHeigth();
      this.showPrompt();
    },
    computed: mapState([
      'KP'
    ]),
    methods:{
      checkFosunShopping () {
        this.$axios.post("/onelink.mdata.main.api/web/checkFosunShopping", {
        }).then((res) => {
          if (res.data.code == '0') {
            if(res.data.data === true){
              this.setToken('supplierActivutyFxg',1);
            }else{
              this.setToken('supplierActivutyFxg',0);
            }
          }
          this.$router.push({path:'/'});
        }).catch((err) => {
          this.$router.push({path:'/'});
          console.log(err)
        })
      },
      mobileBody(){
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          this.mobileHeight = document.body.clientHeight
        }
      },
      resizeBody(){
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          return;
        }else{
          this.bodyHeight = document.body.clientHeight;
        }
      },
      changeVerifyCode(){
        var img = document.getElementById("verifyCode");
        img.src = this.verrifyCodeUrl+"?operateType=login_&?date=" + encodeURI(encodeURI(new Date()));
        this.verifyCodeExt = "";
      },
      checkVerifyCode(){
        if(this.$refs.verifyCode.value != ''){
          this.$axios.post('/onelink.mdata.main.api/kaptcha/verifyKaptcha?vrifyCode='+this.$refs.verifyCode.value+"&operateType=login_", {
          }).then((res) => {
            this.data = res.data;
            let checkFlag = this.data.data;
            if(!checkFlag){
              this.$message({
                    message: "验证码输入错误",
                    type: 'error'
              });
              this.checkVerifyFlag = false;
            }else{
              this.checkVerifyFlag = true;
            }
          }).catch((err) => {
            console.log(err)
          })
        }else{
          this.$message({
            message: "请输入验证码",
            type: 'error'
          });
          return false;
        }

      },

      checkVerifyCodeExt(){
        if(this.$refs.verifyCode.value != ''){
          this.$axios.post('/onelink.mdata.main.api/kaptcha/verifyKaptcha?vrifyCode='+this.$refs.verifyCode.value+"&operateType=login_", {
          }).then((res) => {
            this.data = res.data;
            let checkFlag = this.data.data;
            if(!checkFlag){
              this.$message({
                    message: "验证码输入错误",
                    type: 'error'
              });
              this.checkVerifyFlag = false;
              var img = document.getElementById("verifyCode");
              img.src = this.verrifyCodeUrl+"?operateType=login_&?date=" + encodeURI(encodeURI(new Date()));
            }else{
              this.checkVerifyFlag = true;
              this.login();
            }
          }).catch((err) => {
            console.log(err)
          })
        }else{
          this.$message({
            message: "请输入验证码",
            type: 'error'
          });
          return false;
        }

      },
      loginHeigth(){
        // $("body").height($(window).height());
        $("body").css('position','relative');
        $(".modal-backdrop").remove();
        $('body').removeClass('modal-open');
      },
      login(){
        this.userName  = this.$refs.inputUserName.value;
        this.password = this.$refs.inputPassword.value;
        this.verifyCode = this.verifyCodeExt;
        if(this.loginFailNumber>3){
          this.currentVerifyCode = this.verifyCode;
        }else{
          this.currentVerifyCode = "";
        }
        if(this.userName == ''){
          this.$message({
            message: "请输入注册邮箱",
            type: 'error'
          });
          return false;
        }
        if(this.password.length <6 ||this.password.length >20){
          this.$message({
            message: "密码长度是6-20位，请重新输入",
            type: 'error'
          });
          return false;
        }
        if(this.loginFailNumber>3 &&this.verifyCodeExt == ''){
          this.$message({
            message: "请输入验证码",
            type: 'error'
          });
          return false;
        }

        this.$axios.post('/onelink.mdata.main.api/user/login', {
          userName: this.userName,
          password: this.password,
          rememeberPassword: this.rememeberPassword,
          openId:this.openId,
          verifyCode:this.currentVerifyCode
        }).then((res) => {
          Cookies.remove('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE');
          Cookies.remove('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE2');
          Cookies.set('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE','zh_CN',{domain:'.onelinkplus.com',expires:10});
          Cookies.set('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE2','zh_CN',{domain:'.onelinkplus.com',expires:10});
          this.data = res.data;
          // 登录后全部用户信息
          this.setToken('loginInfo', this.getAesString(JSON.stringify(this.data || {}), this.KP.key, this.KP.iv));
          //登录标记
          this.loginFlag = this.data.loginFlag;
          //用户信息
          this.userInfo = this.data.uCenterMemberInforDto;
          // 埋点
          try {
            sensors.login(this.data.uCenterMemberInforDto.id + '');
          } catch (e) {console.log(e)}

          //用户标签（10：供应商，20：采购商，50：企业管理，00：平台管理）
          this.userTag = this.userInfo.userTag;
          //公司信息
          this.companyInfo = this.data.uCenterMemberInforDto.uCenterORGUserRelationsDto;
          //消息数量
          this.messageNumber = this.data.messageNumber;
          //注册类型标记
          this.regeisterType =this.data.registerType;
          //企业信息是否完善标记
          this.checkFlag = this.data.checkFlag;
          //审批记录信息
          this.checkCardInfo = this.data.checkCardInfo;
          //是否企业管理员
          this.isCompanyManager = this.data.isCompanyManager;
          //登录失败次数
          this.loginFailNumber = this.data.loginFailNumber;
          //协同系统-供应商短授权标记
          this.coordinationSupplierAuthFlag = this.data.coordinationSupplierAuthFlag;
          //协同系统授权标记
          this.coordinationSystemAuthFlag = this.data.coordinationSystemAuthFlag;
          //供应商管理系统授权标记
          this.supplierManagerAuthFlag = this.data.supplierManagerAuthFlag;
          //消息列表
          this.noticeInfos = this.data.noticeInfos;
          //操作标记
          this.isExperience = this.data.isExperience;
          //验证码验证标记
          this.checkVerifyFlag = this.data.checkLoginCodeFlag;
          //明源标记
          this.mingyuanFlag = this.data.mingyuanFlag;
          //是否万邦群组
          this.checkIsWanbangGroup = this.data.checkIsWanbangGroup;
          //供应商注册成功标记
          this.supplierRegeisterSuccessFlag = this.data.supplierRegeisterSuccessFlag;
          // 绑定钉钉号
          this.getDingInfo()
          if(this.supplierRegeisterSuccessFlag){
            this.setToken('supplierRegeisterSuccessFlag',1);
          }else{
            this.setToken('supplierRegeisterSuccessFlag',0);
          }

          if (!this.data.companyCompleteStatus) {
            Cookies.set("COMPANY_COMPLETE_STATUS_"+this.userInfo.companyId,"0",{domain:'.onelinkplus.com',expires:10 });
          }
          if(this.checkIsWanbangGroup){
            this.setToken('checkIsWanbangGroup',this.getAesString("0",this.KP.key,this.KP.iv));
            Cookies.set('checkIsWanbangGroup',"0",{domain:'.onelinkplus.com',expires:10 });
          }else{
            this.setToken('checkIsWanbangGroup',this.getAesString("1",this.KP.key,this.KP.iv));
            Cookies.set('checkIsWanbangGroup',"1",{domain:'.onelinkplus.com',expires:10 });
          }
          let checkIsFosunGroup = this.data.checkIsFosunGroup
          if (checkIsFosunGroup) { // true是1 false是0 与其他人设置的习惯相反...
            this.setToken('checkIsFosunGroup',this.getAesString("0",this.KP.key,this.KP.iv));
            Cookies.set('checkIsFosunGroup',"0",{domain:'.onelinkplus.com',expires:10 });
          }else {
            this.setToken('checkIsFosunGroup', this.getAesString("1", this.KP.key, this.KP.iv));
            Cookies.set('checkIsFosunGroup', "1", {domain: '.onelinkplus.com', expires: 10});
          }
          this.isOperateQuestionNaire = this.data.isOperateQuestionNaire;
          if(this.isOperateQuestionNaire){
            this.setToken('isOperateQuestionNaire',1);
          }else{
            this.setToken('isOperateQuestionNaire',0);
          }
          this.privacyPolicyFlag = this.data.privacyPolicyFlag;
          if(this.privacyPolicyFlag){
            this.setToken('privacyPolicyFlag',1);
          }else{
            this.setToken('privacyPolicyFlag',0);
          }

          this.setToken('mingyuanFlag',this.mingyuanFlag);
          this.setToken('isExperience',this.isExperience)
          Cookies.set('isExperience',this.isExperience,{domain:'.onelinkplus.com',expires:10 });
          Cookies.set('companyName',this.userInfo.companyName,{domain:'.onelinkplus.com',expires:10 });
          this.setToken('regeisterType',this.regeisterType)
          Cookies.set('regeisterType',this.regeisterType,{domain:'.onelinkplus.com',expires:10 });
          this.setToken('noticeInfos',JSON.stringify(this.noticeInfos))
          this.setToken('loginFailNumber',this.loginFailNumber)
          this.setToken('userTag',this.userTag);
          if(this.isCompanyManager){
            this.setToken('isCompanyManager',100);
            Cookies.set('isCompanyManager',100,{domain:'.onelinkplus.com',expires:10 });
          }else{
            this.setToken('isCompanyManager','');
            Cookies.set('isCompanyManager','',{domain:'.onelinkplus.com',expires:10});
          }
          if(Number(this.messageNumber) > 99){
            this.messageNumber = '99+';
          }else{
            this.messageNumber = this.messageNumber;
          }
          this.accountInfo.userName = this.userName;
          this.accountInfo.password = this.password;
          if(this.loginFlag){
            this.checkFosunShopping()
            if(this.coordinationSupplierAuthFlag){
              this.setToken('coordinationSupplierAuthFlag','100');
              Cookies.set('coordinationSupplierAuthFlag','100',{domain:'.onelinkplus.com',expires:10});
            }else{
              this.setToken('coordinationSupplierAuthFlag','200');
              Cookies.set('coordinationSupplierAuthFlag','200',{domain:'.onelinkplus.com',expires:10});
            }
            if(this.coordinationSystemAuthFlag){
              this.setToken('coordinationSystemAuthFlag','100')
              Cookies.set('coordinationSystemAuthFlag','100',{domain:'.onelinkplus.com',expires:10});
            }else{
              this.setToken('coordinationSystemAuthFlag','200')
              Cookies.set('coordinationSystemAuthFlag','200',{domain:'.onelinkplus.com',expires:10});
            }
             if(this.supplierManagerAuthFlag){
                this.setToken('supplierManagerAuthFlag','100')
                Cookies.set('supplierManagerAuthFlag','100',{domain:'.onelinkplus.com',expires:10});
             }else{
               this.setToken('supplierManagerAuthFlag','200')
               Cookies.set('supplierManagerAuthFlag','200',{domain:'.onelinkplus.com',expires:10});

             }

            //设置本地存储及vuex仓库中islogin的状态值
            this.setToken('isLogin',100);
            Cookies.set('isLogin',100,{domain:'.onelinkplus.com',expires:10});
            if(this.checkFlag){
              this.setToken('checkFlag',100);
              Cookies.set('checkFlag',100,{domain:'.onelinkplus.com',expires:10});
            }else{
              this.setToken('checkFlag',200);
              Cookies.set('checkFlag',200,{domain:'.onelinkplus.com',expires:10});
            }
            this.setToken('refSysId',this.getAesString(this.data.refSysId,this.KP.key,this.KP.iv));

            this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
            this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
            this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
            this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

            Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
            if(this.rememeberPassword){
              this.setToken('isRemember',100);
              this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});

              Cookies.set('isRemember',100);
              Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
            }else{
              this.setToken('isRemember','');

              Cookies.set('isRemember','',{domain:'.onelinkplus.com',expires:10});
            }
             this.setToken('examineStatus','');
             Cookies.set('examineStatus','',{domain:'.onelinkplus.com',expires:10});
             this.setToken('exmaineMessage','');
             Cookies.set('exmaineMessage','',{domain:'.onelinkplus.com',expires:10});
             // 福星购领取弹框
            if(this.redirectURL =='' || typeof(this.redirectURL) == "undefined"){
              this.$router.push({path:"/"});
              // if(this.userTag == '20'){
              //   this.$router.push({path:'/purchaser'});
              // }else if(this.userTag == '10'){
              //   // 福星购弹框 -> 跳转供应商首页
              // todo 确认 是否保留
              // }else{
              //   this.$router.push({path:"/"});
              // }

            }else{
               if(this.redirectURL.indexOf('http') == 0){
                  window.location.href = this.redirectURL;
                }else{
                this.$router.push({path:this.redirectURL});
                }
              // window.location.href = this.redirectURL;
            }
          }else{

            if(this.rememeberPassword){
              this.setToken('isRemember',100);
              this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

              Cookies.set('isRemember',100,{domain:'.onelinkplus.com',expires:10});
              Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
            }else{
              this.setToken('isRemember','');

              Cookies.set('isRemember','',{domain:'.onelinkplus.com',expires:10});
            }
            if(this.data.errorInfo == '该账户正在审核中'){
              this.setToken('examineStatus',200);
              this.setToken('exmaineMessage',this.checkCardInfo.checkRemark);

              Cookies.set('examineStatus',200,{domain:'.onelinkplus.com',expires:10});
              Cookies.set('exmaineMessage',this.checkCardInfo.checkRemark,{domain:'.onelinkplus.com',expires:10});
              this.setToken('isLogin',100);
              this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
              this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
              this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
              this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

              Cookies.set('isLogin',100,{domain:'.onelinkplus.com',expires:10});
              Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
              this.$router.push({path:"registerExamine",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName,createUserId:this.userInfo.createUserId}});
            }else if(this.data.errorInfo == '该账户审批未通过'){
              this.setToken('examineStatus',300);
              this.setToken('exmaineMessage',this.checkCardInfo.checkRemark);

              Cookies.set('examineStatus',300,{domain:'.onelinkplus.com',expires:10});
              Cookies.set('exmaineMessage',this.checkCardInfo.checkRemark,{domain:'.onelinkplus.com',expires:10});
              this.setToken('isLogin',100);
              this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
              this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
              this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
              this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

              Cookies.set('isLogin',100,{domain:'.onelinkplus.com',expires:10});
              Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
              this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.regeisterType,exmaineMessage:this.checkCardInfo.checkRemark,createUserId:this.userInfo.createUserId}});
            }else if(this.data.errorInfo == '该微信账号已经与其他一链网账户绑定'){
              this.$message({
                message: '该微信账号已经与其他一链网账户绑定',
                type: 'error'
              });
            }else{

              if(this.data.errorInfo == '验证码输入错误'){
                this.$message({
                  message: '验证码输入错误',
                  type: 'error'
                });
                this.verifyCodeExt = "";
              }else{
                this.$message({
                  message: this.data.errorInfo,
                  type: 'error'
                });
              }
              var img = document.getElementById("verifyCode");
              img.src = this.verrifyCodeUrl+"?operateType=login_&?date=" + encodeURI(encodeURI(new Date()));
              // this.verifyCodeExt = "";
            }

          }
        }).catch((err) => {
          console.log(err)
        })
      },
      checkItem:function(event){
        let checked = event.target.checked;
        let checkDom = this.$refs.loginForm.getElementsByClassName("el-checkbox__original");
        this.rememeberPassword = checked;
        // if(checked){
        //   this.rememeberPassword = checked;
        //   for (let i = 0; i < checkDom.length; i++) {
        //     checkDom[i].checked = true;
        //   }
        // }else{
        //   this.rememeberPassword = checked;
        //   for (let i = 0; i < checkDom.length; i++) {
        //     checkDom[i].checked = false;
        //   }
        // }
      },
      goToRegister () {
        // 埋点
        try {
          customRegisterButtonClick({
            page_title: "登录"
          })
        } catch (e) {console.log(e)}
        this.$router.push({path:"/register"})
      },
      goToRegister2(){

        let sUserAgent = navigator.userAgent;
        if (sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1 || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1) {
            // location.href = '要跳转的手机网址';
          this.$alert('<p>请到电脑端进行账号注册！</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            confirmButtonText:'知道了'
          });
        } else {

          this.$alert('<p>请到电脑端进行请到电脑端进行账号注册！</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            confirmButtonText:'知道了'
          });
        }
      },
      goToHref(val){
        this.$router.push({path: val})
      },
      jump(){
        this.$router.push({path:"/"})
      },
      jumpUrl(url){
        if(url.indexOf('http') == 0){
          window.location.href = url;
        }else{
          this.$router.push({path:url});
        }
      },
      trimEmile(val){
        this.loginUser = val.trim();
      },
      getDingInfo(){
        let that=this
        // const s = document.createElement('script');
        // s.type = 'text/javascript';
        // s.src = 'https://oapi.fosun.com/m/js/fosun_oapi_login-2.0.0_v2.js';
        // document.body.appendChild(s);
        // const s1 = document.createElement('script');
        // s1.type = 'text/javascript';
        // s1.src = 'http://o.fosun.com/mobile_portal/fosun/server/return.js';
        // document.body.appendChild(s1);

        fosun_oapi_login.getDDAccount(function(user){
          //
          // alert('fosun_oapi_login')
          // alert(JSON.stringify(user))
          // alert(that.syncDingdAccount)
          that.syncDingdAccount(1,user,()=>{

            // this.$confirm('钉钉编号和邮箱信息不匹配，是否强制更新?', '提示', {
            //   confirmButtonText: '更新',
            //   cancelButtonText: '取消',
            //   customClass:'mobileText mobileText2',
            //   type: 'warning'
            // }).then(() => {
            //   this.syncDingdAccount(1,user)
            // }).catch(() => {
            //   this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            //   });
            // });
          })

        });
      },
      syncDingdAccount(force=0,user,cb){
            // alert(JSON.stringify(user))
            // alert(this.userInfo.id)
        // force 0 默认 1强制更新
          this.$axios.post(`/onelink.mdata.main.api/thirdPartyLogin/syncDingdAccount?mobile=${user.mobile1}&email=${user.email}&dingCode=${user.dd_id}&userId=${this.userInfo.id}&force=${force}`).then((res) => {
            // alert(JSON.stringify(res))
            if(res.data.code=='1'){

            // alert(JSON.stringify(res))
              cb&&cb()
            }
          }).catch(err=>{
            // alert(err)
          })
      },
      // 关闭提示新一链入口的操作
      toNewSite() {
        this.switchPrompt = false;
        if(this.checkedPrompt){
          Cookies.set('noPrompt',this.checkedPrompt,{domain:'.onelinkplus.com',expires:10});
        }
      },
      // 判断是否显示新一链入口的提示
      showPrompt(){
        if(Cookies.get("noPrompt") == 'true'){
          this.switchPrompt = false;
        }
      }
    
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/login.vue